module.exports = __webpack_public_path__ + "img/Rectangle_18P.742a1304.png";